/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/10/19
 * Time: 10:46 AM
 */
import React from 'react';
import {connect} from 'react-redux'
import * as actionCreators from '../../store/Action'
import Image_uploader from '../../assets/img/img_upload/upload.svg'
import * as common from "../../const/Common/CommonFunc";

class ImageUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      imagePreviewUrl: '',
      liveImage: ''
    };
  }

  _handleSubmit(e) {
    e.preventDefault();
  }

  _handleImageChange(e) {
    const urlArray = [];
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    if(file) {
      if (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg") {
        reader.onloadend = () => {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result
          });
        };

        reader.readAsDataURL(file);
        urlArray.push(reader);
        this.props.imageUploaderHandler(urlArray);
      } else {
        common.notifyMessage("Please choose valid file type (jpg/jpeg/png)")
      }
    }
  }

  render() {
    let {imagePreviewUrl} = this.state;
    let $imagePreview = null;
    if ((this.props.img_url !== '' && this.state.imagePreviewUrl !== '') || (this.props.img_url === '' && this.state.imagePreviewUrl !== '')) {
      $imagePreview = (<img src={imagePreviewUrl} style={{
        width: '200px',
        height: '200px',
        objectFit: 'scale-down',
        border: '1px #9a9a9a dotted',
        cursor: 'pointer'
      }}/>);

    } else {
      $imagePreview = (<div className="previewText"
                            style={this.props.image ? isImage : isNotImage}
      >
        <img style={this.props.image ? isImageTag : isNotImageTag}
             src={this.props.image ? this.props.image : Image_uploader}/>

      </div>);
    }

    return (

      <div className="previewComponent">
        <form onSubmit={(e) => this._handleSubmit(e)}>
          <input className="fileInput"
                 id="image-upload-visitortags"
                 type="file"
                 accept="image/png, image/jpeg"
                 style={{
                   display: 'none',
                   cursor: 'pointer',
                   zIndex: '1',
                   position: 'absolute',
                   marginTop: '0%',
                   opacity: '0',
                   width: '200px',
                   height: '200px',
                 }}
                 onChange={(e) => this._handleImageChange(e)}/>
        </form>
        <label htmlFor={"image-upload-visitortags"} className="imgPreview" style={{
          textAlign: 'center',
          boxShadow: '0px 15px 20px rgba(0, 0, 0, 0.1)',
          backgroundColor: this.props.white ? '#00ff51' : '#414141',
          background: 'transparent',
          width: '200px',
          height: '200px',

        }}>
          {$imagePreview}
        </label>
      </div>
    )
  }
}

let isImageTag = {
  height: '200px',
  width: '200px',
  objectFit: 'contain'
};

let isNotImageTag = {
  height: '45%',
};


let isImage = {
  width: '200px',
  height: '200px',
  color: 'white',
  border: '1px #9a9a9a dotted',
  cursor: 'pointer'
};
let isNotImage = {
  width: '200px',
  height: '200px',
  color: 'white',
  paddingTop: '30%',
  border: '1px #9a9a9a dotted',
  cursor: 'pointer'
};

const mapDispatchToProps = (dispatch) => {
  return {
    imageUploaderHandler: (image) => dispatch(actionCreators.imageUploaderHandler(image))
  }
};

export default connect(null, mapDispatchToProps)(ImageUpload);
